module.exports = __webpack_public_path__ + "img/3.fea99bc1.svg";